import { render, staticRenderFns } from "./companyBasic.vue?vue&type=template&id=5788438a"
import script from "./companyBasic.vue?vue&type=script&lang=js"
export * from "./companyBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports